module.exports = __webpack_public_path__ + "static/img/pd_detail_3.520bb70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_detail_3.jpg
// module id = cD3l
// module chunks = 52